export const Units = [
    {id: 0, name: "cm", un : "Centimeters"},
    {id: 1, name: "m", un : "Meters" },
    {id: 2, name: "mm", un : "Millimeters"},
    {id: 3, name: "ft", un : "Feet/Foot"},
    {id: 4, name: "in", un : "Inches"},
]